/**
 * @shelf-version: 1.0.0
 */


import PageCssVariables from './page-css-variables';

export default PageCssVariables;
